import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/clinical-solutions/clinical-staffing-solutions")({
  head: () => buildRouteHead("/en/services/clinical-solutions/clinical-staffing-solutions", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/services/clinical-solutions/clinical-expert-services", replace: true });
  },
});
